import React, { useState } from 'react';
import { Grid, Tabs, Tab, Box } from '@mui/material';

import { useGetWebhookQuery } from '@services';

import WebhookList from './WebhookList/WebhookList';
import { WebhookEndpoints } from '@models';

const webhooks = [
  {
    title: 'State based pricing',
    moduleName: 'STATE_BASED',
  },
  {
    title: 'Manual order',
    moduleName: 'MANUAL_ORDER',
  },
  {
    title: 'Product update',
    moduleName: 'PRODUCT_UPDATE',
  },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index } = props;
  return <>{value === index && <Box sx={{ width: '100%' }}>{children}</Box>}</>;
};

const WebhookPage = () => {
  const { data, refetch } = useGetWebhookQuery();
  const [webhookTab, setWebhookTab] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setWebhookTab(newValue);
  };

  const getWebhookLists = (moduleName: string, webhooks: WebhookEndpoints[]) =>
    webhooks?.filter((webhook) => webhook.module === moduleName);

  return (
    <Grid container spacing={2} alignItems="center" py={2} data-testid="webhook-page">
      <Box sx={{ width: '100%' }}>
        <Tabs value={webhookTab} onChange={handleChange}>
          <Tab label="State based pricing"></Tab>
          <Tab label="Manual order"></Tab>
          <Tab label="Product update"></Tab>
        </Tabs>
      </Box>
      <TabPanel value={webhookTab} index={0}>
        <WebhookList
          testId="state-based-webhook"
          title={webhooks[0].title}
          moduleName={webhooks[0].moduleName}
          initialLists={getWebhookLists(webhooks[0].moduleName, data as WebhookEndpoints[]) ?? []}
          refetch={refetch}
        ></WebhookList>
      </TabPanel>
      <TabPanel value={webhookTab} index={1}>
        <WebhookList
          testId="manual-based-webhook"
          title={webhooks[1].title}
          moduleName={webhooks[1].moduleName}
          initialLists={getWebhookLists(webhooks[1].moduleName, data as WebhookEndpoints[]) ?? []}
          refetch={refetch}
        ></WebhookList>
      </TabPanel>
      <TabPanel value={webhookTab} index={2}>
        <WebhookList
          testId="product-update-webhook"
          title={webhooks[2].title}
          moduleName={webhooks[2].moduleName}
          initialLists={getWebhookLists(webhooks[2].moduleName, data as WebhookEndpoints[]) ?? []}
          refetch={refetch}
        ></WebhookList>
      </TabPanel>
    </Grid>
  );
};

export default WebhookPage;
